import React from "react";
import Page from "../Page";

const SI = ({ testResult }) => {
  return (
    <>
      <Page testResult={testResult} title="معرفی الگوی رفتاری SI">
        <p className="text-gray-800 leading-7">
          افراد با الگوی رفتاری SI ترکیبی متعادل از دو سبک در مدل DISC هستند:
          ثبات‌گرایی (S) و تأثیرگذاری (I). این افراد حمایت‌گر، صبور و در عین‌حال
          گرم و اجتماعی‌اند؛ معمولاً در جمع محبوب‌اند و با مهربانی و حوصله
          ارتباط برقرار می‌کنند. آن‌ها به دنبال محیطی امن و همدلانه هستند و در
          نقش‌های مشاوره‌ای یا حمایتی خوب عمل می‌کنند.
        </p>
      </Page>

      <Page testResult={testResult} title="ویژگی‌های بارز تیپ SI">
        <div className="text-gray-800 leading-7 space-y-3">
          <ul className="list-disc list-inside space-y-2">
            <li>در جمع راحت است اما مرکز توجه نیست.</li>
            <li>مهربان، صمیمی و قابل‌اعتماد.</li>
            <li>عاشق کمک به دیگران؛ اغلب نقش شنونده یا میانجی را دارد.</li>
            <li>در تصمیم‌گیری به احساسات و نیازهای اطرافیان توجه می‌کند.</li>
            <li>
              وفادار و پایدار در رابطه‌ها؛ روابط کم اما عمیق ترجیح می‌دهد.
            </li>
          </ul>
        </div>
      </Page>

      <Page testResult={testResult} title="نقاط قوت اصلی">
        <div className="text-gray-800 leading-7">
          <ul className="list-disc list-inside space-y-2">
            <li>حمایت‌گری و همراهی موثر با دیگران</li>
            <li>سازگاری و انعطاف‌پذیری در تعاملات</li>
            <li>گرم و دلگرم‌کننده بودن در ارتباط</li>
            <li>صبر، تحمل و ثبات رفتاری</li>
            <li>وفاداری و تعهد به تیم و دوستان</li>
            <li>روحیه مثبت و آرامش‌بخش</li>
          </ul>
        </div>
      </Page>

      <Page testResult={testResult} title="چالش‌های احتمالی">
        <div className="text-gray-800 leading-7">
          <ul className="list-disc list-inside space-y-2">
            <li>مشکل در گفتن «نه» و قرار گرفتن در موقعیت‌های اضافه‌بار</li>
            <li>اجتناب از مواجهه با تعارض حتی وقتی لازم است</li>
            <li>وابستگی بیش‌ازحد به حفظ رابطه‌ها</li>
            <li>نگرانی از نادیده گرفته شدن یا طرد اجتماعی</li>
          </ul>
        </div>
      </Page>

      <Page testResult={testResult} title="فضای ایده‌آل برای رشد">
        <div className="text-gray-800 leading-7">
          <ul className="list-disc list-inside space-y-2">
            <li>محیطی حمایت‌کننده و پایدار با روابط معنادار</li>
            <li>فشار رقابتی کم و تمرکز بر همکاری تیمی</li>
            <li>نقش‌هایی که امکان راهنمایی، مشاوره یا همراهی فراهم کند</li>
            <li>فرصت‌های کار گروهی و مشارکت در تصمیم‌گیری‌های جمعی</li>
          </ul>
        </div>
      </Page>

      <Page testResult={testResult} title="مثال واقعی شخصیت سینمایی">
        <p className="text-gray-800 leading-7">
          "سمویس گمگی" (Samwise Gamgee) در ارباب حلقه‌ها: شخصیتی وفادار، حمایتگر
          و آرام که در لحظات بحرانی پشتیبان دوستانش است؛ نمونه‌ای خوب از
          رفتارهای SI در موقعیت‌های تیمی و حمایتی.
        </p>
      </Page>

      <Page testResult={testResult} title="پیشنهاد فیلم">
        <div className="text-gray-800 leading-7">
          <p className="mb-2">The Intouchables (2011) — دست‌نیافتنی‌ها</p>
          <p>
            فیلمی فرانسوی دربارهٔ رابطهٔ صمیمی بین یک مرد معلول و پرستارش؛
            نمونه‌ای از ترکیب مهربانی، حمایت و انرژی مثبت که ابعاد I و S را نشان
            می‌دهد.
          </p>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="ابعاد و توصیف ویژگی‌های رفتاری در الگوی SI"
      >
        <div className="text-gray-800 leading-7">
          <p>
            افراد SI ترکیبی از تمایل به ثبات (S) و گرایش به تأثیرگذاری (I)
            دارند: هدف اصلی آن‌ها ایجاد پیوندهای انسانی، حفظ آرامش گروه و تشویق
            دیگران است. رفتار آن‌ها معمولاً آرام، همراه و همدلانه است.
          </p>
        </div>
      </Page>

      <Page testResult={testResult} title="مهم‌ترین ابعاد رفتاری تیپ SI">
        <div className="overflow-x-auto">
          <table className="w-full text-right border border-gray-300 border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 p-3 font-semibold">
                  توصیف عملکرد
                </th>
                <th className="border border-gray-300 p-3 font-semibold">
                  بعد رفتاری
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3">
                  دوستانه، خون‌گرم، حمایتگر. به احساسات دیگران توجه زیادی دارد.
                </td>
                <td className="border border-gray-300 p-3">تعامل اجتماعی</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">
                  در موقعیت‌های استرس‌زا آرام باقی می‌ماند. تغییرات ناگهانی را
                  نمی‌پسندد.
                </td>
                <td className="border border-gray-300 p-3">پایداری و ثبات</td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  تأثیرگذار با استفاده از مهربانی، داستان‌سرایی، و احساسات مثبت.
                  نه از طریق فشار یا منطق خشک.
                </td>
                <td className="border border-gray-300 p-3">نفوذ کلامی</td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  بیشتر با گفت‌وگو، مشورت و حفظ آرامش حل می‌کند تا تقابل و سرعت
                  عمل.
                </td>
                <td className="border border-gray-300 p-3">حل مسئله</td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  به‌شدت تیم‌محور و وفادار به ارزش‌های گروه. با افراد ناسازگار
                  یا رقابتی دچار تنش می‌شود.
                </td>
                <td className="border border-gray-300 p-3">تیم‌گرایی</td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  غیرمستقیم، مؤدبانه و با در نظر گرفتن حال دیگران. گاهی نیازهای
                  خود را قربانی می‌کند.
                </td>
                <td className="border border-gray-300 p-3">نحوه بیان نیاز</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Page>

      <Page testResult={testResult} title="رفتار SI در محیط‌های مختلف">
        <p className="text-gray-800 leading-7">
          در خانه: مهربان، دلسوز، صبور. گاهی با توقعات پنهان از اعضای خانواده که
          بیان نمی‌شود. در کار: میانجی تیم، اهل گوش دادن، انگیزه‌بخش، مناسب برای
          نقش‌های منابع انسانی، آموزش و پشتیبانی. در بحران: تلاش می‌کند صلح و
          ثبات را حفظ کند. از برخورد مستقیم یا تنش دوری می‌کند. مثال شخصیت
          واقعی: "مادر ترزا" ، نماد انسان‌دوستی، آرامش، عشق به مردم، خدمت
          بی‌چشم‌داشت و حمایت از ضعیف‌ترین اقشار.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهاد فیلم/سریال برای شناخت بهتر شخصیت SI"
      >
        <p className="text-gray-800 leading-7">
          "ویلیام ترنر" در فیلم دزدان دریایی کارائیب ، شخصیتی وفادار، حمایت‌گر،
          آرام اما مؤثر در شرایط بحرانی. در تمام قسمت‌ها ترجیح می‌دهد از دل
          ارتباطات، مسائل را حل کند نه با خشونت. اعجوبهWonder 2017 ، داستان پسری
          با نیازهای ویژه که خانواده‌اش خصوصاً مادرش ترکیبی از عشق، حمایت، و
          تأثیرگذاری هستند. This Is Us سریال این ما هستیم ، در شخصیت‌هایی مثل
          "جک پیرسون"، ترکیب مهربانی، فداکاری و نفوذ عاطفی را به‌وضوح می‌بینیم.
        </p>
      </Page>

      <Page testResult={testResult} title="تشریح الگوی رفتاری SI در عمل">
        <p className="text-gray-800 leading-7">
          افراد با الگوی SI ترکیبی خاص از دو نیروی مهم رفتاری را در خود دارند:
          تأثیرگذاری اجتماعی I ثبات رفتاری و عاطفی S این ترکیب، آن‌ها را به
          رهبرهای محبوب، همدل و در عین حال متعهد و وفادار تبدیل می‌کند. آن‌ها
          روابط انسانی را در اولویت قرار می‌دهند و در هر تیم یا جمعی نقش «چسب»
          را بازی می‌کنند؛ یعنی به انسجام، صمیمیت و هماهنگی کمک می‌کنند.
        </p>
      </Page>

      <Page testResult={testResult} title="1. سبک تعامل و ارتباطات">
        <p className="text-gray-800 leading-7">
          افراد SI دلسوز، خوش‌برخورد و همدل هستند. در ارتباطات خود از لبخند،
          نگاه مهربان، تماس چشمی و شنیدن فعال استفاده می‌کنند. با زبان بدن آرام
          و گفتار گرم و دوستانه، دیگران را به خود جذب می‌کنند. گاهی برای جلوگیری
          از ناراحت کردن دیگران، از ابراز نظر صریح اجتناب می‌کنند. مثال عملی: در
          یک جلسه کاری، فرد SI معمولاً با احترام به نظرات دیگران، جو آرامی ایجاد
          می‌کند و اگر دو نفر دچار تنش شوند، وارد می‌شود تا با لطافت آن را
          مدیریت کند.
        </p>
      </Page>

      <Page testResult={testResult} title="2. در تیم چگونه عمل می‌کنند؟">
        <p className="text-gray-800 leading-7">
          در تیم نقش حامی اجتماعی، تسهیل‌گر و میانجی دارند. به شدت بر حفظ همدلی،
          احساس امنیت روانی و آرامش تیمی متمرکز هستند. اهل رقابت شدید نیستند،
          بلکه همکاری و حمایت متقابل را ترویج می‌دهند. در صورت بروز اختلاف،
          بیشتر مایل‌اند با گفت‌وگو و صبوری مشکل را حل کنند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="3. نحوه مدیریت و رهبری
"
      >
        <p className="text-gray-800 leading-7">
          رهبران SI معمولاً مورد علاقه زیردستان هستند. با صبوری، تشویق، آموزش و
          محبت تیم را هدایت می‌کنند. به کارکنان فرصت رشد می‌دهند و با تعهد به
          روابط انسانی بلندمدت، اعتماد ایجاد می‌کنند. اما در مواجهه با تعارض‌های
          شدید یا تصمیم‌گیری‌های سخت، ممکن است دچار تعلل شوند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="4. چالش‌های رفتاری افراد  SI
"
      >
        <p className="text-gray-800 leading-7">
          اجتناب از تعارض: ممکن است به دلیل ترس از ناراحت کردن دیگران، حرف دل
          خود را نزنند. عدم قاطعیت در تصمیم‌گیری: به ویژه در شرایط بحرانی.
          فداکاری بیش از حد: گاهی نیازهای خود را فدای دیگران می‌کنند. تأثیرپذیری
          زیاد از احساسات دیگران: ممکن است دچار فرسودگی عاطفی شوند.
        </p>
      </Page>

      <Page testResult={testResult} title="5. ویژگی‌های رفتاری بارز">
        <div className="overflow-x-auto">
          <table className="w-full text-right border border-gray-300 border-collapse">
            <thead>
              <tr className="bg-gray-100">
                <th className="border border-gray-300 p-3 font-semibold">
                  شرح
                </th>
                <th className="border border-gray-300 p-3 font-semibold">
                  ویژگی
                </th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td className="border border-gray-300 p-3">
                  با همه احساس همدلی و همدردی دارند
                </td>
                <td className="border border-gray-300 p-3">همدلی</td>
              </tr>
              <tr>
                <td className="border border-gray-300 p-3">
                  در برقراری ارتباط صادقانه و عمیق موفق‌اند
                </td>
                <td className="border border-gray-300 p-3">صمیمیت</td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  به تیم، سازمان، دوستان و خانواده وفادار می‌مانند
                </td>
                <td className="border border-gray-300 p-3">وفاداری</td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  اغلب نزد دیگران بسیار دوست‌داشتنی هستند
                </td>
                <td className="border border-gray-300 p-3">محبوبیت</td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  محیط را آرام و بدون تنش نگه می‌دارند
                </td>
                <td className="border border-gray-300 p-3">آرامش‌بخش</td>
              </tr>

              <tr>
                <td className="border border-gray-300 p-3">
                  به‌خوبی به دیگران گوش می‌دهند و احساس درک‌شدن را منتقل می‌کنند
                </td>
                <td className="border border-gray-300 p-3">شنوندگی فعال</td>
              </tr>
            </tbody>
          </table>
        </div>
      </Page>

      <Page
        testResult={testResult}
        title="فیلم پیشنهادی برای درک بهتر شخصیت SI"
      >
        <p className="text-gray-800 leading-7">
          فیلم: Patch Adams با بازی رابین ویلیامز یک پزشک انسان‌دوست، با قلبی
          بزرگ و رفتاری اجتماعی و حمایت‌گر که به جای درمان صرف، روح بیماران را
          شفا می‌دهد. شخصیت اصلی فیلم نمونه‌ای کامل از الگوی SI است.
        </p>
      </Page>

      <Page testResult={testResult} title="انگیزه‌های افراد با الگوی رفتاری SI">
        <p className="text-gray-800 leading-7">
          افراد با تیپ رفتاری SI ترکیب تأثیرگذاری اجتماعی بالا و ثبات رفتاری
          عمیقاً انسان‌محور هستند. انگیزه‌های اصلی آن‌ها برخاسته از روابط
          انسانی، حس تعلق، تأیید اجتماعی و احساس مفید بودن برای دیگران است.
        </p>
      </Page>

      <Page testResult={testResult} title="مهم‌ترین محرک‌های انگیزشی افراد SI">
        <p className="text-gray-800 leading-7">
          آن‌ها دوست دارند در محیط‌هایی باشند که دوستی، محبت و صمیمیت وجود دارد.
          تأیید اجتماعی از اطرافیان برایشان بسیار مهم است. وقتی بخشی از یک تیم
          منسجم هستند، انرژی می‌گیرند. رقابت زیاد یا جو تنش‌زا انگیزه آن‌ها را
          کاهش می‌دهد.
        </p>
      </Page>

      <Page testResult={testResult} title="مهم‌ترین محرک‌های انگیزشی افراد SI">
        <p className="text-gray-800 leading-7">
          ثبات شغلی، روابط بلندمدت و قابل اعتماد برای آن‌ها انگیزه‌بخش است. از
          محیط‌های استرس‌زا، پرتنش یا غیردوستانه دوری می‌کنند. انگیزه بسیار
          بالایی دارند وقتی حس کنند در حال بهبود زندگی دیگران هستند. اگر بدانند
          بودنشان تفاوتی ایجاد می‌کند، با تمام توان عمل می‌کنند. تشویق، توجه و
          قدردانی مداوم آن‌ها را شارژ می‌کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="چه چیزی انگیزه آن‌ها را کاهش می‌دهد؟"
      >
        <p className="text-gray-800 leading-7">
          نادیده گرفتن احساساتشان یا بی‌اعتنایی به آن‌ها قطع ناگهانی رابطه یا
          دوری عاطفی قرار گرفتن در رقابت‌های تند و جوهای قدرت‌محور عدم قدردانی
          از تلاش‌ها و حمایت‌هایشان واگذاری تصمیم‌گیری‌های سخت بدون حمایت
        </p>
      </Page>

      <Page testResult={testResult} title="مثال عملی">
        <p className="text-gray-800 leading-7">
          مریم، یک مشاور منابع انسانی با الگوی SI است. در زمانی که مدیرش از او
          در جلسه‌ای قدردانی می‌کند و به او اجازه می‌دهد تیم آموزش را با سبک
          خودش مدیریت کند، عملکردش چند برابر می‌شود. اما اگر از او بخواهند در
          جلسه‌ای پرتنش قاطعانه با یک کارمند خاطی برخورد کند، بدون همراهی عاطفی،
          احتمالاً مضطرب می‌شود یا عقب می‌کشد.
        </p>
      </Page>

      <Page testResult={testResult} title="پیشنهاد فیلم مرتبط با انگیزه‌های SI">
        <p className="text-gray-800 leading-7">
          فیلم: The Blind Side نقطه کور شخصیت مادر با بازی ساندرا بولاک نمادی از
          انگیزه‌های SI است: پذیرش، حمایت، مهربانی و ایجاد محیط امن برای رشد
          دیگران.
        </p>
      </Page>

      <Page testResult={testResult} title="عادت‌های کاری در الگوی رفتاری SI">
        <p className="text-gray-800 leading-7">
          افراد دارای الگوی رفتاری SI، در محیط کار به عنوان همکارانی وفادار،
          صبور، همدل و حمایت‌گر شناخته می‌شوند. آن‌ها عاشق تعامل اجتماعی، همکاری
          گروهی و ایجاد فضای دوستانه هستند و هم‌زمان تلاش می‌کنند از تنش و
          درگیری دوری کنند.
        </p>
      </Page>

      <Page testResult={testResult} title="ویژگی‌ها و عادات کاری بارز افراد SI">
        <p className="text-gray-800 leading-7">
          کار تیمی و مشارکتی قوی ترجیح می‌دهند در کنار دیگران کار کنند و نه
          به‌تنهایی. در هماهنگی و ایجاد فضای صمیمی بین اعضای تیم بسیار مؤثرند.
          تعهد و وفاداری بالا نسبت به مدیر، سازمان و تیم خود وفادارند. حتی در
          شرایط سخت می‌مانند. مقاومت در برابر تغییرات ناگهانی
        </p>
      </Page>

      <Page testResult={testResult} title="ویژگی‌ها و عادات کاری بارز افراد SI">
        <p className="text-gray-800 leading-7">
          با تغییرات سریع یا تصمیم‌گیری‌های بدون مقدمه مشکل دارند. نیاز به زمان
          برای پذیرش دارند. همیشه در دسترس و یاری‌رسان اگر کسی به کمک نیاز داشته
          باشد، بدون تأخیر حاضر می‌شوند حتی اگر حجم کار خودشان زیاد باشد. احساس
          مسئولیت انسانی نسبت به دیگران احساس می‌کنند مسئول ایجاد آرامش و رضایت
          دیگران هستند؛ گاهی حتی به قیمت نادیده گرفتن نیازهای خودشان. پرهیز از
          تعارض و عدم درگیری مستقیم در مواقعی که نیاز به موضع‌گیری جدی است، ممکن
          است سکوت یا کناره‌گیری کنند.
        </p>
      </Page>

      <Page testResult={testResult} title="فرصت‌های رشد و توسعه در عادات کاری">
        <p className="text-gray-800 leading-7">
          یادگیری مهارت «نه گفتن» تمرین تصمیم‌گیری مستقل اولویت‌بندی کارها و
          کاهش تمایل به انجام همه درخواست‌ها پذیرش اینکه مخالفت یا بازخورد منفی
          همیشه نشانه طرد شدن نیست
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهاد فیلم برای درک بهتر عادات کاری"
      >
        <p className="text-gray-800 leading-7">
          فیلم: Pay It Forward به دیگری نیکی کن قهرمان داستان با ذهنیت SI، سعی
          می‌کند با مهربانی، ایجاد ارتباط و کمک به دیگران، جهان را جای بهتری
          کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="دیدگاه‌ها و نگرش‌های افراد با الگوی SI"
      >
        <p className="text-gray-800 leading-7">
          افراد SI دنیا را جایی می‌بینند که باید در آن امنیت، صمیمیت، مهربانی و
          همدلی برقرار باشد. آن‌ها نگاه‌شان به زندگی، انسان‌محور، پر از تعاملات
          دوستانه و مبتنی بر اعتماد و رابطه است. این نگرش، رفتار آن‌ها در محیط
          کار و زندگی شخصی را شکل می‌دهد. دنیا را جایی می‌دانند که اگر افراد با
          یکدیگر مهربان باشند، همه‌چیز بهتر پیش می‌رود. جهان‌بینی آن‌ها مثبت اما
          نه لزوماً خوش‌بینانه افراطی است؛ بلکه همراه با احتیاط در برابر
          بی‌اعتمادی و طرد شدن. نسبت به مردم: به انسان‌ها با دیدگاه پذیرنده،
          قابل اعتماد و مهربان نگاه می‌کنند، مگر اینکه خلافش ثابت شود. عاشق
          روابط پایدار، دوستانه و دور از تنش‌اند. رفتارهای برگرفته از این
          دیدگاه‌ها: در پروژه‌های جدید، ابتدا دنبال حس «آشنایی» و «حمایت»
          می‌گردند تا اعتماد شکل بگیرد. اگر احساس کنند طرد شده‌اند یا دیده
          نمی‌شوند، از درون تخریب می‌شوند اما بیرونی آرام دارند. در
          تصمیم‌گیری‌ها به اثر آن بر «رابطه» بیشتر توجه دارند تا فقط «نتیجه».
        </p>
      </Page>

      <Page testResult={testResult} title="اوقات فراغت در الگوی رفتاری SI">
        <p className="text-gray-800 leading-7">
          افراد با تیپ رفتاری SI، در اوقات فراغت به دنبال فعالیت‌هایی هستند که:
          به رابطه انسانی و تعاملات دوستانه معنا بدهد. حسی از امنیت، پذیرش، تعلق
          و صمیمیت را فراهم کند. به آن‌ها اجازه دهد در کنار دیگران، اما در فضایی
          آرام و بدون تنش، انرژی بگیرند.
        </p>
      </Page>

      <Page testResult={testResult} title="ویژگی‌های بارز اوقات فراغت SI ها">
        <p className="text-gray-800 leading-7">
          ترجیح می‌دهند با افراد نزدیک و مورد اعتماد وقت بگذرانند نه در جمع‌های
          شلوغ و ناآشنا. فعالیت‌هایی را انتخاب می‌کنند که هم آرامش‌بخش است و هم
          امکان تعامل فراهم می‌کند مثل پیاده‌روی‌های دونفره، مهمانی‌های
          دوستانه‌ی محدود، یا کمک به خیریه‌ها. اغلب علاقه‌مند به سرگرمی‌های جمعی
          سبک هستند؛ مثل بازی‌های گروهی ساده، دیدن فیلم با دیگران، آشپزی با
          دوستان، یا سفرهای کوتاه خانوادگی.
        </p>
      </Page>

      <Page testResult={testResult} title="نمونه فعالیت‌های محبوب برای SI ها">
        <p className="text-gray-800 leading-7">
          کتاب‌خوانی در کنار یک دوست یا در باشگاه کتاب پیک‌نیک خانوادگی یا
          دوستانه در محیطی دنج و خلوت دیدن فیلم‌های احساسی با دیگران فعالیت‌های
          داوطلبانه یا حمایتی مثل حضور در مؤسسات خیریه یا کمک به همسایه‌ها
          هنرهای دستی یا آشپزی با کسی که دوستش دارند
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهاد فیلم مناسب اوقات فراغت افراد SI"
      >
        <p className="text-gray-800 leading-7">
          فیلم: The Intouchables دست‌نیافتنی‌ها این فیلم داستان دو شخصیت از
          دنیای متفاوت را روایت می‌کند که با محبت، همدلی و ارتباط صادقانه، زندگی
          یکدیگر را متحول می‌کنند. یک فیلم ایده‌آل برای تیپ SI که نشان می‌دهد
          چگونه روابط انسانی می‌تواند زندگی را زیبا و معنادار کند.
        </p>
      </Page>

      <Page testResult={testResult} title="تصمیم‌گیری در الگوی رفتاری SI">
        <p className="text-gray-800 leading-7">
          افراد با الگوی SI در تصمیم‌گیری‌هایشان بیشتر احساس‌محور، ملاحظه‌کار و
          همدلانه هستند. برای آن‌ها «احساس دیگران»، «پایداری روابط» و «احترام به
          ارزش‌های اجتماعی و اخلاقی» در تصمیم‌گیری اهمیت بالایی دارد.
        </p>
      </Page>

      <Page testResult={testResult} title="ویژگی‌های تصمیم‌گیری SI ها">
        <p className="text-gray-800 leading-7">
          کند ولی دقیق: این افراد برای گرفتن تصمیم عجله نمی‌کنند. دوست دارند قبل
          از تصمیم‌گیری، تمام جنبه‌ها را بسنجند و مطمئن شوند کسی از تصمیم‌شان
          ناراحت یا متضرر نمی‌شود. تحت تأثیر محیط عاطفی: اگر در فضایی قرار
          بگیرند که تنش یا فشار باشد، ممکن است تصمیم‌گیری برایشان سخت شود یا به
          تعویق بیفتد. جلب رضایت جمع: تلاش می‌کنند تصمیمی بگیرند که همه یا
          اکثریت از آن راضی باشند؛ حتی اگر خودشان ترجیح دیگری داشته باشند. حساس
          به پیامدهای احساسی تصمیم: به این فکر می‌کنند که تصمیم‌شان چه تأثیری
          روی حال و دل دیگران می‌گذارد. وابستگی به تأیید اجتماعی یا گروهی: گاهی
          نیاز دارند از دیگران مشورت بگیرند یا تأیید شوند تا تصمیم بگیرند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نقاط قوت تصمیم‌گیری SI ها
"
      >
        <p className="text-gray-800 leading-7">
          تصمیم‌هایشان با ملاحظه، انسانی و مسئولانه است. به تعهدات بلندمدت و
          اثرات اجتماعی تصمیم‌ها توجه می‌کنند. در شرایط پیچیده، تصمیمی می‌گیرند
          که آرامش و همدلی جمع را حفظ کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="چالش‌های احتمالی در تصمیم‌گیری SI ها"
      >
        <p className="text-gray-800 leading-7">
          ممکن است در موقعیت‌های بحرانی یا رقابتی، دیر تصمیم بگیرند یا مردد
          بمانند. اگر بین انتخابی منطقی و انتخابی احساسی قرار بگیرند، گاهی ترجیح
          می‌دهند دل کسی را نشکنند تا اینکه تصمیم درست‌تری بگیرند. در
          تصمیم‌گیری‌های مهم کاری یا مالی، ممکن است نیاز به همراهی یا راهنمایی
          داشته باشند.
        </p>
      </Page>

      <Page testResult={testResult} title="مثال واقعی">
        <p className="text-gray-800 leading-7">
          یک معلم SI، در موقعیتی قرار گرفت که باید یکی از دو دانش‌آموز را برای
          شرکت در مسابقه‌ای مهم انتخاب می‌کرد. با اینکه یکی از دانش‌آموزان
          شایستگی بیشتری داشت، اما چون نگران بود دانش‌آموز دیگر دلخور شود و
          انگیزه‌اش از بین برود، تصمیم‌گیری برایش بسیار دشوار شد. او در نهایت با
          برگزاری مشورت گروهی بین دانش‌آموزان، تصمیم را به رأی گذاشت تا احساس
          مسئولیت و مشارکت را حفظ کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="پیشنهادات عملی برای بهبود عملکرد افراد با الگوی SI"
      >
        <p className="text-gray-800 leading-7">
          افراد دارای تیپ رفتاری SI ترکیبی از گرمی اجتماعی و ثبات رفتاری افرادی
          هستند وفادار، صبور، صمیمی، همدل و قابل اعتماد. اما برای افزایش
          بهره‌وری، پیشرفت شخصی و تأثیرگذاری در نقش‌های حرفه‌ای، لازم است برخی
          مهارت‌ها و نگرش‌ها را تقویت کنند.
        </p>
      </Page>

      <Page testResult={testResult} title="الف. پیشنهادات برای رشد فردی">
        <p className="text-gray-800 leading-7">
          جرأت‌ورزی Assertiveness را تمرین کنید به جای اجتناب از تعارض یا گفتن
          «بله» به همه، یاد بگیرید خواسته‌های خود را محترمانه ولی قاطع بیان
          کنید. حد و مرزهای سالم تعیین کنید اینکه بخواهید به همه کمک کنید
          ارزشمند است، اما اگر از خودتان غافل شوید، فرسوده می‌شوید. «نه» گفتن را
          تمرین کنید.
        </p>
      </Page>

      <Page testResult={testResult} title="الف. پیشنهادات برای رشد فردی">
        <p className="text-gray-800 leading-7">
          مدیریت زمان و اولویت‌بندی را جدی بگیرید چون SIها دوست دارند برای
          دیگران وقت بگذارند، ممکن است در اولویت‌های شخصی یا کاری‌شان دچار
          اختلال شوند. توسعه تفکر تحلیلی و تصمیم‌گیری مستقل تمرین کنید برای
          تصمیم‌گیری منتظر تأیید دیگران نباشید. از مدل‌هایی مانند تحلیل SWOT یا
          درخت تصمیم‌گیری برای تمرین بهره ببرید.
        </p>
      </Page>

      <Page testResult={testResult} title="ب. پیشنهادات برای رشد شغلی">
        <p className="text-gray-800 leading-7">
          جرأت ارائه ایده‌ها در جلسات به جای سکوت یا تأیید دیگران، حتی اگر با
          احتیاط، نظر خودتان را مطرح کنید. یادگیری مهارت‌های ارائه و سخنرانی چون
          ارتباط‌گیرندگان خوبی هستید، این مهارت را می‌توانید سریعاً تقویت و از
          آن بهره ببرید.
        </p>
      </Page>

      <Page testResult={testResult} title="ب. پیشنهادات برای رشد شغلی">
        <p className="text-gray-800 leading-7">
          تمرین در موقعیت‌های چالش‌برانگیز یا رقابتی اگر در فضایی با رقابت یا
          فشار آرام‌آرام قرار بگیرید، تاب‌آوری‌تان بیشتر می‌شود. از پروژه‌های
          کوچک شروع کنید. توسعه مهارت‌های حل مسئله و مدیریت تعارض گاهی SIها از
          تعارض فرار می‌کنند، اما در محیط‌های حرفه‌ای، مهارت حل تعارض به صورت
          فعال، ارزشمند است. پیشنهاد کتاب: Crucial Conversations گفتگوهای سرنوشت
          ساز، درباره گفت‌وگوهای دشوار
        </p>
      </Page>

      <Page testResult={testResult} title="ج. خودشناسی و مراقبت شخصی">
        <p className="text-gray-800 leading-7">
          بازخورد بگیرید از افرادی که به آن‌ها اعتماد دارید. دفترچه روزانه
          موفقیت داشته باشید و در آن پیشرفت‌ها، موفقیت‌های کوچک و تجربیات
          یادگیری‌تان را بنویسید. تمرین مراقبه یا مدیتیشن برای آرامش درونی و حفظ
          تعادل عاطفی.
        </p>
      </Page>

      <Page testResult={testResult} title="چند تمرین کاربردی">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="رمز موفقیت افراد با الگوی SI">
        <p className="text-gray-800 leading-7">
          افراد دارای الگوی رفتاری SI ترکیب تأثیرگذاری گرم سبک I با ثبات و حمایت
          سبک S ، از نظر عاطفی هوشمند، خوش‌برخورد، وفادار و قابل اعتماد هستند.
          اما رمز موفقیت آن‌ها در دنیای حرفه‌ای و شخصی، در آگاهی از ظرفیت‌های
          درونی و استفاده آگاهانه از آن‌هاست.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="الف. رمزموفقیت در زندگی شخصی و اجتماعی"
      >
        <p className="text-gray-800 leading-7">
          حفظ صمیمیت، بدون فداکاری بیش از حد SIها دوست دارند همه را راضی نگه
          دارند. اما باید یاد بگیرند که رضایت خودشان، اولویت اول است. رمز: «هر
          کمکی که به دیگران می‌کنم، باید از یک منِ کامل‌تر بیاید، نه از یک منِ
          فرسوده.» تعادل بین سازگاری و ابراز وجود شخصیت SI تمایل زیادی به
          سازگاری دارد. برای موفقیت، باید جرأتِ نشان دادن تفاوت‌ها و ابراز
          نیازهای شخصی را تمرین کند.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="الف. رمزموفقیت در زندگی شخصی و اجتماعی"
      >
        <p className="text-gray-800 leading-7">
          ارتباط عاطفی قدرتمند با مرزهای مشخص آن‌ها در همدلی بی‌نظیرند، اما برای
          موفقیت باید یاد بگیرند ارتباطات‌شان را مدیریت کنند. تمرین پیشنهادی: در
          یک گفت‌وگوی احساسی، تلاش کنید شنونده بمانید اما خودتان را گم نکنید.
        </p>
      </Page>

      <Page testResult={testResult} title="ب. رمزهای موفقیت در شغل و تیم کاری">
        <p className="text-gray-800 leading-7">
          تبدیل حمایت‌گری به رهبری تأثیرگذار SIها رهبران بی‌سروصدا هستند. وقتی
          بر اعتماد به نفس‌شان کار کنند، می‌توانند رهبرانی محبوب، ثابت‌قدم و
          الهام‌بخش شوند. پیشنهاد فیلم: Coach Carter ، نمونه‌ای از یک رهبر گرم،
          حمایتی و اثرگذار. اعتماد به شهود اجتماعی SIها در تشخیص حس و حال دیگران
          عالی‌اند. اگر از این ویژگی برای مدیریت روابط، همکاری و حل تعارض
          استفاده کنند، تیمی متحد خواهند ساخت.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ب. رمزهای موفقیت در شغل و تیم کاری
"
      >
        <p className="text-gray-800 leading-7">
          ورود به حوزه‌های تصمیم‌سازی باید یاد بگیرند از نقش «اجرا» به سمت
          نقش‌های «طراحی و تصمیم‌گیری» حرکت کنند. رمز: «تو فقط خوب انجام
          نمی‌دهی؛ خوب می‌فهمی که باید چه انجام شود.»
        </p>
      </Page>

      <Page testResult={testResult} title="ج. ذهنیت موفق SIها">
        <p className="text-gray-800 leading-7">
          سکوت همیشه نشانه‌ی درک نیست؛ گاهی باید صحبت کرد. تواضع ارزش است، اما
          موفقیت جسارت می‌خواهد. مهربانی بدون مرز، تبدیل به وظیفه‌ی بی‌اجر
          می‌شود.
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="نحوه تعدیل و تقویت ویژگی‌های تیپ  SI"
      >
        <p className="text-gray-800 leading-7">
          افراد با الگوی رفتاری SI، ترکیبی از گرمی، وفاداری، همکاری و ثبات
          رفتاری هستند. با وجود این ویژگی‌های ارزشمند، برای پیشرفت و رضایت
          بیشتر، نیاز است برخی خصوصیاتشان را تقویت و برخی را تعدیل کنند. در
          ادامه، راهکارهایی برای هر دو جنبه آورده شده است.
        </p>
      </Page>

      <Page testResult={testResult} title=" ویژگی‌هایی که باید تقویت شوند">
        <p className="text-gray-800 leading-7">
          ابراز وجود Assertiveness افراد SI گاهی به دلیل پرهیز از تعارض،
          خواسته‌ها و نظراتشان را بیان نمی‌کنند. تقویت: تمرین جمله‌سازی با
          ساختار «من احساس می‌کنم... چون...» شرکت در کارگاه‌های مهارت‌های
          جرأت‌ورزی فیلم پیشنهادی: The King's Speech ، درباره قدرت یافتن صدا و
          ابراز وجود
        </p>
      </Page>

      <Page
        testResult={testResult}
        title=" ویژگی‌هایی که باید تقویت شوند
"
      >
        <p className="text-gray-800 leading-7">
          تصمیم‌گیری قاطعانه آن‌ها به دلیل توجه زیاد به نظر دیگران، گاهی در
          تصمیم‌گیری مردد می‌مانند. تقویت: اولویت‌بندی ارزش‌های شخصی تمرین
          تصمیم‌گیری در زمان محدود یادگیری چارچوب‌هایی مثل ماتریس آیزنهاور
        </p>
      </Page>

      <Page testResult={testResult} title="ویژگی‌هایی که باید تقویت شوند">
        <p className="text-gray-800 leading-7">
          اعتماد به نفس حرفه‌ای گاهی خود را دست‌کم می‌گیرند و دیده نمی‌شوند.
          تقویت: بازخورد گرفتن از افراد معتبر فهرست‌برداری از موفقیت‌های گذشته
        </p>
      </Page>

      <Page
        testResult={testResult}
        title="ویژگی‌هایی که نیاز به تعدیل دارند
"
      >
        <p className="text-gray-800 leading-7">
          تمایل بیش از حد به راضی نگه داشتن دیگران مهربانی زیاد گاهی به فرسایش
          شخصی می‌انجامد. تعدیل: آموختن گفتن «نه» با احترام تفکیک بین «نیاز
          دیگران» و «وظیفه من» کتاب پیشنهادی: When I Say No, I Feel Guilty
          روانشناسي اعتراض (وقتي نه مي‌گويم احساس گناه مي‌كنم)
        </p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>

      <Page testResult={testResult} title="">
        <p className="text-gray-800 leading-7"></p>
      </Page>
    </>
  );
};

export default SI;
